import _extends from 'babel-runtime/helpers/extends';

import TableList from '@/components/TableList/index.vue';
import { mapState } from 'vuex';
import { format } from 'date-fns';
import AutoTips from '@/components/AutoTips/index.vue';
import _ from 'lodash';
import { language } from '@/common/storage';
import ShowTipContent from '@com/components/show-tips-content/index.vue';
import { downloadWithIframe } from '@/common/download';
import ProjectInfoDialog from '@pt/views/common-template/components/project-info/dialog.vue';
import ProjectInfo from '@pt/views/common-template/components/project-info/info.vue';
import AutoTableColumn from '@com/pt-components/pt-table/AutoTableColumn';
import ActionGroup from '@pt/views/pt-entry/components/action-group/index.vue';
import PtStatus from '@com/pt-components/pt-status/index.vue';
import AutoFoldLabel from '@com/components/auto-fold-label';
import NameId from '@pt/views/pt-entry/components/name-id.vue';

export default {
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    config: {
      type: Object
    },
    allCount: {
      type: Number
    },
    handlePreview: [Function]
  },
  components: {
    TableList: TableList,
    AutoTips: AutoTips,
    ShowTipContent: ShowTipContent,
    ProjectInfoDialog: ProjectInfoDialog,
    ProjectInfo: ProjectInfo,
    AutoTableColumn: AutoTableColumn,
    ActionGroup: ActionGroup,
    PtStatus: PtStatus,
    AutoFoldLabel: AutoFoldLabel,
    NameId: NameId
  },
  data: function data() {
    return {
      pagination: {
        total: 1
      },
      projectInfoDialog: {
        visible: false,
        data: {}
      },
      orientationOptions: [{
        value: 3,
        label: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.adaptive.label')
      }, {
        value: 1,
        label: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.landscape.label')
      }, {
        value: 2,
        label: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.portrait.label')
      }]
    };
  },

  methods: {
    getLanguage: function getLanguage() {
      return language.get();
    },
    handlePreviewClick: function handlePreviewClick(item) {
      var temp = _.cloneDeep(item);
      temp.preview_url = item.preview_urls || '';
      this.handlePreview(temp);
    },
    handleDownload: function handleDownload(item) {
      downloadWithIframe(item.download_url);
    },
    handleInfo: function handleInfo(item) {
      this.projectInfoDialog.visible = true;
      var ios = item.app_info.find(function (item) {
        return item.platform === 'ios';
      });
      var android = item.app_info.find(function (item) {
        return item.platform === 'android';
      });
      var orient = this.orientationOptions.find(function (item) {
        return Number(item.value) === Number(item.orientation);
      });
      var data = {
        name: item.name,
        platform: item.app_info.map(function (item) {
          return item.platform;
        }).join(','),
        promoted_type: item.promoted_type,
        orientation: orient ? orient.label : '',
        iosUrl: ios ? ios.app_url : '',
        iosIcon: ios ? ios.app_icon : '',
        iosName: ios ? ios.app_name : '',
        androidUrl: android ? android.app_url : '',
        androidIcon: android ? android.app_icon : '',
        androidName: android ? android.app_name : '',
        lang: item.language || '',
        account: item.target_adv_name
      };
      this.projectInfoDialog.data = data;
    },
    firstUpperCase: function firstUpperCase(str) {
      return str.replace(/\b(\w)(\w*)/g, function ($0, $1, $2) {
        return $1.toUpperCase() + $2.toLowerCase();
      });
    },
    getStatusText: function getStatusText(status) {
      var message = '';
      switch (true) {
        case status === 'pending':
          message = this.$t('playTurbo.commonTemplate.works.status.pending');
          break;
        case status === 'approved':
          message = this.$t('playTurbo.common.pushRecordDialog.statusList.approved');
          break;
        case status === 'rejected':
        case status === 'failed':
          message = this.$t('playTurbo.common.pushRecordDialog.statusList.failed');
          break;
        case status === 'downloaded':
          message = this.$t('playTurbo.common.pushRecordDialog.statusList.downloaded');
          break;
        case status === 'partSuccess':
          message = this.$t('playTurbo.commonTemplate.works.status.partSuccess');
          break;
        default:
          message = this.$t('playTurbo.common.pushRecordDialog.statusList.other');
          break;
      }
      return message;
    },
    getStatusValue: function getStatusValue(status) {
      var str = '';
      switch (true) {
        case status === 'pending':
          str = 'pending';
          break;
        case status === 'approved':
        case status === 'downloaded':
          str = 'success';
          break;
        case status === 'rejected':
        case status === 'failed':
          str = 'fail';
          break;
        case status === 'partSuccess':
          str = 'warning';
          break;
        default:
          str = '';
          break;
      }
      return str;
    },
    getActionsByRow: function getActionsByRow(rowData) {
      var self = this;
      var temp = [{
        visible: true,
        label: this.$t('playTurbo.common.pushRecordDialog.table.preview'),
        icon: 'visible',
        delay: 600,
        onClick: function onClick(row, action) {
          self.handlePreviewClick(row);
        }
      }, {
        label: self.$t('playTurbo.common.pushRecordDialog.table.download'),
        visible: rowData.status === 'downloaded' && !self.userInfo.is_subscribe_expired,
        loading: false,
        icon: 'download',
        delay: 600,
        onClick: function onClick(row, action) {
          self.handleDownload(row);
        }
      }, {
        visible: true,
        label: self.$t('playTurbo.common.pushRecordDialog.table.info'),
        loading: false,
        icon: 'project_information',
        delay: 600,
        onClick: function onClick(row, action) {
          self.handleInfo(row);
        }
      }];
      return temp.filter(function (item) {
        return item.visible;
      });
    },
    toggleRowExpansion: function toggleRowExpansion(row) {
      row.expanded = !row.expanded;
      var table = this.$refs.table.$refs.table;
      table.toggleRowExpansion(row, row.expanded);
    },
    isEnabledAnalyze: function isEnabledAnalyze(mod, creativesInfo) {
      // 下载项目的mod=gmaker 、ps 且 creatives_info.channel_id= 1
      return ['gmaker', 'ps'].includes(mod) && creativesInfo.channel_id === 1;
    },
    getFirstFingerprint: function getFirstFingerprint(rowData) {
      var item = rowData.creatives_info[0];
      if (item && item.fingerprint) {
        return item.fingerprint;
      }

      return '';
    }
  },

  computed: _extends({}, mapState({
    userInfo: function userInfo(state) {
      return state.user.info;
    }
  }), {
    tableColWidth: function tableColWidth() {
      return {
        title: 150
      };
    },
    tableColumnConfig: function tableColumnConfig() {
      var _this = this;

      return [{
        slot: 'expand'
      }, {
        prop: 'basic-id-cell',
        slot: 'basic-id-cell'
      }, {
        label: this.$t('playTurbo.common.pushdownloadRecordDialog.table.channel'),
        prop: 'channel_name',
        columnComponent: AutoTableColumn,
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return '<span class="channel-name">' + row.channel_name + '</span>';
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }, {
        prop: 'status-cell',
        slot: 'status-cell',
        align: 'left'
      }, {
        visible: function visible(_ref2) {
          var row = _ref2.row;

          return _this.config.from === 3 || _this.config.from === 4;
        },
        label: this.$t('playTurbo.common.pushdownloadRecordDialog.table.count'),
        prop: 'count',
        columnComponent: AutoTableColumn,
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return '<span class="count-num">' + row.count + '</span>';
          }
        }
      }, {
        label: this.$t('playTurbo.common.pushdownloadRecordDialog.table.updateTime'),
        prop: 'created_time',
        minWidth: '170px',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            var time = row.created_time ? '' + format(row.created_time * 1000, 'YYYY/MM/DD HH:mm') : '-';
            return '<span class="push-time">' + time + '</span>';
          }
        }
      }];
    },
    innerList: function innerList() {
      var _this2 = this;

      return this.list.map(function (item) {
        var cookTitle = '';
        if (item.name) {
          cookTitle = item.name.substring(0, 5) + '...' + item.name.substring(item.name.length - 15);
        }
        return _extends({}, item, {
          cooTitle: _this2.config.type === 'material' ? cookTitle : item.name
        });
      });
    },
    costTotal: function costTotal() {
      return this.$t('playTurbo.common.historyList.table.column.countAll') + '\n      ' + this.allCount;
    }
  })
};